<template>
  <div>
    <div class="login-block">
      <div class="logo-login"></div>
      <div class="login-title">ScentScraper</div>
      <div class="login-form">
        <div v-if="error" class="login-form-row">
          <div class="error-text">
            {{ this.errorMessage }}
          </div>
        </div>

        <div class="login-form-row">
          <label class="credentials user" for="username"></label>
          <input
            id="username"
            v-model="username"
            type="text"
            placeholder="B2B portal email"
          />
        </div>

        <div class="login-form-row">
          <label class="credentials lock" for="password"></label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="B2B portal password"
            @keyup.enter="login"
          />
        </div>

        <div class="login-form-row">
          <button class="login-button" v-on:click="login">Submit</button>
        </div>

        <div class="login-form-row spacebetween">
          <div class="remember">
            <input type="checkbox" id="checkbox" v-model="checked" />
            <label class="remember-label" for="checkbox">Remember me</label>
          </div>

          <a
            class="rememberandforget"
            href="https://b2b.sense-company.com/password/reset"
            >Forgot password?</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { b2b_portal_api_url } from "@/constants/endpoints";

export default {
  name: "Login",
  methods: {
    login() {
      let email = this.username;
      let password = this.password;

      let user = {
        email,
        password,
      };

      fetch(b2b_portal_api_url + "session", {
        method: "post",
        body: JSON.stringify(user),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success === true) {
            const token = response.data.token;
            const userEmail = response.data.email;

            localStorage.setItem("token", token);
            localStorage.setItem("userEmail", userEmail);

            this.$emit("update", "login");
          }
          if (response.success === false) {
            this.error = true;
            this.errorMessage = response.data;
            this.password = "";
            localStorage.removeItem("token");
            localStorage.removeItem("userEmail");
          }
        });
    },
  },
  data() {
    return {
      username: "",
      password: "",
      checked: false,
      error: false,
      errorMessage: "",
    };
  },
};
</script>

<style></style>
